import {FlexPage} from '@hconnect/common/components'
import {Box, Stack} from '@mui/material'

type LayoutProps = {
  titleSlot?: React.ReactNode
  aboveTitleSlot?: React.ReactNode
  kilnMonitoringSlot: React.ReactNode
  workOrdersSummarySlot: React.ReactNode
  plantStatusKpisSlot: React.ReactNode
  operationHoursSlot: React.ReactNode
  rcfaSlot: React.ReactNode
  myTasksSlot: React.ReactNode
  downtimeByCategorySlot: React.ReactNode
  isTablet: boolean
}

export const PlantDashboardMobileLayout: React.FC<LayoutProps> = ({
  titleSlot,
  aboveTitleSlot,
  kilnMonitoringSlot,
  workOrdersSummarySlot,
  plantStatusKpisSlot,
  operationHoursSlot,
  rcfaSlot,
  myTasksSlot,
  downtimeByCategorySlot,
  isTablet
}) => {
  return (
    <FlexPage
      title={titleSlot}
      aboveTitle={aboveTitleSlot}
      nameHeaderSx={{mt: aboveTitleSlot ? 0 : undefined}}
    >
      <Stack spacing={1} useFlexGap flex={1} direction="row" flexWrap="wrap">
        {plantStatusKpisSlot}
        {kilnMonitoringSlot}
        {operationHoursSlot}
        <Stack spacing={2} flex={1} direction={isTablet ? 'row' : 'column'} useFlexGap>
          <Box flex={1}>{downtimeByCategorySlot}</Box>
        </Stack>
        <Stack spacing={1} flex={1} direction={isTablet ? 'row' : 'column'} useFlexGap>
          <Box sx={{display: 'flex', flex: '1 0 0'}}>{workOrdersSummarySlot}</Box>
          <Stack spacing={isTablet ? 2 : 1} flex={1} useFlexGap flexWrap="wrap">
            <Box sx={{display: 'flex', flex: '1 0 0'}}>{rcfaSlot}</Box>
            <Box sx={{display: 'flex', flex: '1 0 0'}}>{myTasksSlot}</Box>
          </Stack>
        </Stack>
      </Stack>
    </FlexPage>
  )
}
